
<ion-content class="garment-listing">
    <app-header [isParentPage]="false" [title]="'Special Cancel Report'"></app-header>
    <div class="loading-container" style="padding-top:15%;" *ngIf="!loaded">
        <ion-spinner></ion-spinner>
    </div>
 <ng-container>
        <ion-grid>
            <ion-row class="filter-row">
                <ion-grid>
                    <ion-row>
                      <ion-col size="12" size-md="2.5" style="padding-top:25px;padding-left:10px">
                             <ion-row>
                              <span  style="color:white" >Enter A Customer Code.</span>
                            </ion-row>
                        </ion-col>
                        <ion-col  size="12" size-md="6" >
                            <ion-row>
                                <ion-input type="text"  [(ngModel)]="customerCode" class="ion-text-left " placeholde="Please enter customer code "  (keydown.enter)="onEnterKey($event)"></ion-input>
                              </ion-row>
                            
                        </ion-col>
                         <ion-col size="12" size-md="0.8"  >
                             <ion-button  color="gallaghergreen" class="btn-box-shadow" (click)="getCustomerReport()" ><span>Show</span></ion-button>
                         </ion-col>  
                     </ion-row>
                </ion-grid>

            </ion-row >
               <ion-row style="padding-top:100px" *ngIf="isShowData && (cancelOrders.length > 0)">
                <ion-grid class="inner-grid">
                    <ion-row>
                          <ion-col class="ion-no-padding"  *ngIf="cancelOrders && cancelOrders[0] && cancelOrders[0][0]">
                             <ion-col size="auto">  <strong>Cust:</strong> &nbsp;&nbsp;{{customerCode}}</ion-col>  
                            <ion-col size="auto">&nbsp; {{ cancelOrders[0][0].customerName }}</ion-col>
                          </ion-col>
                         
                        <ion-col class="ion-no-padding" size="auto"><b>Report Date: </b> {{currentDate | date: 'shortDate'}}</ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col class="ion-no-padding">
                            <ion-col size="auto"><strong>Dept:</strong>&nbsp;&nbsp;{{cancelOrders?.[0]?.[0]?.departmentCode}}</ion-col>
                            <ion-col size="auto">&nbsp;&nbsp;&nbsp; {{cancelOrders?.[0]?.[0]?.departmentName}}</ion-col>
                        </ion-col>
                         <ion-col class="ion-no-padding" size="auto">
                              <button class="printer-button hidden-for-print" (click)="changePrinterView()">{{viewChange === true ? 'Regular Version' : 'Printer Friendly Version'}}</button>
                          </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-row>
       <div *ngIf="isShowData" class="cancel-container" >
            <ion-grid *ngFor="let wo of cancelOrders" class="main-grid">
                <ion-row>
                    <ion-col class="bold">
                        {{wo[0].lastName}}, {{wo[0].firstName}}  {{wo[0].departmentCode}}-{{wo[0].employeeCode}}
                    </ion-col>
                   
                    <ion-col>
                        <strong>Start Date:</strong> {{wo[0].orderDate | date: 'MM/dd/yyyy'}}
                    </ion-col>
                </ion-row>
                <ion-row class="ion-justify-content-end ion-align-items-center">
                    <ion-col class="ion-justify-content-end ion-align-items-center">
                        <strong>Stop:</strong> {{wo[0].stopName}}
                    </ion-col>
                    <ion-col class="ion-justify-content-end ion-align-items-center">
                        <strong>Gar. ID Label:</strong> {{wo[0].stopCode}} {{wo[0].lockerNum}}
                    </ion-col>
                     <ion-col>
                        <strong>Cancel Order:</strong> {{wo[0].woCode}}
                      </ion-col>
                </ion-row>
                <ion-grid class="data-grid">
                    <ion-row class="data-headers">
                      <ion-col size="2.1">
                        <strong>Description</strong>
                      </ion-col>
                      <ion-col size="4.2">
                        <strong>Product</strong>
                      </ion-col>
                      <ion-col size="2.1">
                        <strong>Barcode #</strong>
                      </ion-col>
                      <ion-col size="2.1">
                        <strong>Date Collected</strong>
                      </ion-col>
                      <ion-col size="1.5" style="text-align: right;">
                        <strong>Loss Charge</strong>
                      </ion-col>
                    </ion-row>
    
                    <ion-row *ngFor="let item of wo">
                      <ion-col size="2.1">
                        {{item.description}}
                      </ion-col>
                      <ion-col size="4.2">
                        {{item.product}}
                      </ion-col>
                      <ion-col size="2.1">
                        {{item.barcode}}
                      </ion-col>
                      <ion-col size="2.1">
                        {{item.dateCollected === null ? 'Not Collected' : item.dateCollected | date: 'MM/dd/yyyy'}}
                      </ion-col>
                      <ion-col size="1.5" style="text-align: right;">
                        {{item.dateCollected === null ? (item.lossCharge | currency: 'USD') : '$0.00'}}
                      </ion-col>
                    </ion-row>
                    <ion-row class="data-footer">
                       <ion-col size="10">
                               <strong>Final Pickup Date and Potential Charges: {{wo[0].pickUpDate | date: 'shortDate'}}</strong> 
                        </ion-col>
                        
                        <ion-col size="2" style="text-align: right;">
                            <strong>{{wo.lossCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-grid>
            <ion-grid>
                <ion-row class="grand-total" *ngIf="cancelOrders.length > 0">
                    <ion-col size="10">
                        <strong>Grand Total Potential Loss Charge</strong>
                    </ion-col>
                    <ion-col size="2" style="text-align: right;">
                        <strong>{{totalLossCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </ion-col>
                </ion-row>
               
            </ion-grid>
        </div>
          <ion-row class="no-work-orders" *ngIf="cancelOrders.length <= 0">
                    <ion-col>
                        No cancel Orders
                    </ion-col>
                 </ion-row>
   </ion-grid>
</ng-container>

</ion-content>

